define(["require", "exports", "jquery", "./addToCart", "./analytics"], function (require, exports, $, addToCart_1, analytics_1) {
    "use strict";
    exports.__esModule = true;
    function updateSheerPrice($sheerFabric) {
        var $asset = $sheerFabric.find('.asset');
        var grade = $asset.data('asset_grade');
        var assetId = $asset.data('asset_id');
        var imgSrc = $asset.attr('src');
        var $container = $asset.closest('.cart-addon-item');
        var price = $container.find(".attributes.hidden[data-asset_grade=\"" + grade + "\"]").data('addon-price');
        var $productImage = $container.closest('.cart-item-row').find('td.productpicture img');
        $productImage.attr('src', imgSrc);
        $container.find('.addon-item-unit-price').text(price);
    }
    exports.updateSheerPrice = updateSheerPrice;
    function addPillows(e, apiUrl) {
        var $container = $(e.currentTarget).closest('.cart-item-row');
        var $variants = $container.find('.cart-addon-item:visible .addon-item-picked:checked + label + .product-variant-block');
        var xhr = addToCart_1["default"](e, apiUrl, $variants);
        return xhr;
    }
    function addSheers(e, apiUrl) {
        var $container = $(e.currentTarget).closest('.cart-item-row');
        var $selected = $container.find('.asset-box.selected').find('img');
        var grade = $selected.data('asset_grade');
        var fabricId = $selected.data('asset_id');
        var $attributes = $container.find(".cart-addon-item:visible .attributes.hidden[data-asset_grade=\"" + grade + "\"]");
        var $variant = $container.find('.cart-addon-item:visible .product-variant-block');
        $attributes.find('input[type="hidden"][data-attribute_name="fabricId"]').val(fabricId);
        $attributes.appendTo($variant);
        var xhr = addToCart_1["default"](e, apiUrl, $variant);
        return xhr;
    }
    function submitAddOnItem(e, apiUrl) {
        analytics_1["default"]('cart', 'submitAddOnItem');
        var $cur = $(e.currentTarget);
        if ($cur.hasClass('add-pillow')) {
            return addPillows(e, apiUrl);
        }
        if ($cur.hasClass('add-sheer')) {
            return addSheers(e, apiUrl);
        }
        return null;
    }
    exports.submitAddOnItem = submitAddOnItem;
    function updateSheerSize($sel) {
        if ($sel.hasClass('number') && $sel[0].tagName === "SELECT") {
            var $desc = $sel.prev('.attribute-description').find('.attribute-current');
            $desc.text($sel.val() + " " + $sel.data('attribute-unit'));
        }
    }
    exports.updateSheerSize = updateSheerSize;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/addOnItem.js
// module id = 78
// module chunks = 0